import { render, staticRenderFns } from "./RateMyAgent.vue?vue&type=template&id=4e8e7a8a&scoped=true&"
import script from "./RateMyAgent.vue?vue&type=script&lang=ts&"
export * from "./RateMyAgent.vue?vue&type=script&lang=ts&"
import style0 from "./RateMyAgent.vue?vue&type=style&index=0&id=4e8e7a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e7a8a",
  null
  
)

export default component.exports